/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */

import TableComponent from '../../../components/TableComponent';
import { Listing } from '../../../types/General';

type props = {
  columns: any;
  rows: Listing[];
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
};

const NewIndividualListings = ({ rows, columns, count, page, onPageChange, loading }: props) => {
  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default NewIndividualListings;
